module.exports = {"430581001":"辕门口街道","430581002":"迎春亭街道","430581003":"法相岩街道","430581004":"水西门街道","430581100":"邓元泰镇","430581101":"湾头桥镇","430581102":"文坪镇","430581103":"荆竹铺镇","430581104":"稠树塘镇","430581105":"邓家铺镇","430581106":"龙溪镇","430581107":"司马冲镇","430581108":"秦桥镇","430581109":"双牌镇","430581110":"大甸镇","430581204":"马坪乡","430581205":"晏田乡","430581207":"水浸坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430581.json
// module id = 1983
// module chunks = 0